/* import __COLOCATED_TEMPLATE__ from './summary.hbs'; */
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { CASH_APP_BITCOIN_DEEP_LINK } from '@banking/ui/utils/constants';
import { select } from '@banking/ui/services/investments-workflow';
import { balance, primaryBalance, pendingBalance, secondaryBalance, showPrimaryAsCents, showSecondaryAsCents, rotateDisplayModeAction } from '@banking/ui/workflows/investments';
let InvestmentsSummary = (_dec = select(balance), _dec2 = select(pendingBalance), _dec3 = select(primaryBalance), _dec4 = select(secondaryBalance), _dec5 = select(showPrimaryAsCents), _dec6 = select(showSecondaryAsCents), (_class = class InvestmentsSummary extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "investments", _descriptor, this);
    _initializerDefineProperty(this, "screen", _descriptor2, this);
    _initializerDefineProperty(this, "features", _descriptor3, this);
    _initializerDefineProperty(this, "investmentsWorkflow", _descriptor4, this);
    _initializerDefineProperty(this, "isModalOpen", _descriptor5, this);
    _defineProperty(this, "cashAppDeepLink", CASH_APP_BITCOIN_DEEP_LINK);
    _initializerDefineProperty(this, "balance", _descriptor6, this);
    _initializerDefineProperty(this, "pendingBalance", _descriptor7, this);
    _initializerDefineProperty(this, "primaryBalance", _descriptor8, this);
    _initializerDefineProperty(this, "secondaryBalance", _descriptor9, this);
    _initializerDefineProperty(this, "showPrimaryAsCents", _descriptor10, this);
    _initializerDefineProperty(this, "showSecondaryAsCents", _descriptor11, this);
  }
  get mobileRedirect() {
    return this.screen.isMobile;
  }
  get balanceNumberModifierClass() {
    if (!this.features.isEnabled('squareinvest/bitcoin_fiat_conversion')) {
      return '';
    }
    return 'banking-jumbotron__amount-with-leading-space';
  }
  rotateDisplayMode() {
    this.investmentsWorkflow.emit(rotateDisplayModeAction());
  }
  openManageInCash() {
    this.isModalOpen = true;
  }
  closeManageInCash() {
    this.isModalOpen = false;
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "investments", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "screen", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "investmentsWorkflow", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "isModalOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "balance", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "pendingBalance", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "primaryBalance", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "secondaryBalance", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "showPrimaryAsCents", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "showSecondaryAsCents", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "rotateDisplayMode", [action], Object.getOwnPropertyDescriptor(_class.prototype, "rotateDisplayMode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openManageInCash", [action], Object.getOwnPropertyDescriptor(_class.prototype, "openManageInCash"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeManageInCash", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeManageInCash"), _class.prototype)), _class));
export { InvestmentsSummary as default };